/**
 * Single source of truth for the Bulk Upload screen.
 *
 * Every tab, endpoint and file rule lives here, so adding another bulk upload
 * type means appending one entry below - no component, hook or service needs
 * to change.
 */

/** Module code used for action-level access checks. */
export const BULK_MODULE_CODE = "SETN_BULK";

export const BULK_UPLOAD_TYPE = {
  AG_MEMBER: "AG_MEMBER",
  ORDER: "ORDER",
  PROPOSAL_FORM: "PROPOSAL_FORM",
  PAYMENT: "PAYMENT",
};

/** Limits applied in the browser before a file is sent. */
export const FILE_CONSTRAINTS = {
  acceptedExtensions: [".xlsx", ".xls", ".csv"],
  maxSizeMb: 10,
};

export const BYTES_PER_KB = 1024;
export const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;

export const BulkUploadConfigJSON = [
  {
    id: BULK_UPLOAD_TYPE.AG_MEMBER,
    title: "Bulk AG Member",
    icon: "ri-user-shared-line",
    badge: { text: "MSCDA", color: "primary" },
    entityLabel: "AG member",
    endpoint: "/agsp/customer/bulkCreateMscdaMembers",
    templateKey: "bulk_member",
    resultFilePrefix: "bulk-ag-member",
    description:
      "Upload a spreadsheet to create MSCDA AG members in bulk. The result file lists the outcome of every row.",
  },
  {
    id: BULK_UPLOAD_TYPE.ORDER,
    title: "Bulk Order",
    icon: "ri-shopping-bag-3-line",
    badge: { text: "MSCDA Order", color: "info" },
    entityLabel: "order",
    endpoint: "/agsp/order/bulkCreateOrder",
    templateKey: "bulk_order",
    resultFilePrefix: "bulk-order",
    description:
      "Upload a spreadsheet to create orders in bulk. The result file lists the outcome of every row.",
  },
  {
    id: BULK_UPLOAD_TYPE.PROPOSAL_FORM,
    title: "Bulk Proposal Form",
    icon: "ri-file-list-3-line",
    badge: { text: "MSCDA", color: "primary" },
    entityLabel: "proposal form",
    // TODO: confirm endpoint and templateKey with backend.
    endpoint: "/agsp/order/bulkUpdateProposalForm",
    templateKey: "bulk_proposal_form",
    resultFilePrefix: "bulk-proposal-form",
    description:
      "Upload a spreadsheet to submit MSCDA proposal forms in bulk. The result file lists the outcome of every row.",
  },
  {
    id: BULK_UPLOAD_TYPE.PAYMENT,
    title: "Bulk Payment",
    icon: "ri-bank-card-line",
    badge: { text: "For All AG", color: "success" },
    entityLabel: "payment",
    endpoint: "/payment/bulkManualPayment",
    templateKey: "bulk_payment",
    resultFilePrefix: "bulk-payment",
    description:
      "Upload a spreadsheet to record manual payments in bulk. The result file lists the outcome of every row.",
  },
];

export const DEFAULT_BULK_UPLOAD_TYPE = BulkUploadConfigJSON[0].id;

/** @returns {object|undefined} The config entry for a tab id. */
export const getBulkUploadConfig = (id) =>
  BulkUploadConfigJSON.find((entry) => entry.id === id);
